import { FC } from 'react';
import styles from './PrismColorDropdown.module.scss';
import { Formik, Form } from 'formik';
import ToggleField from '../Inputs/ToggleField';
import Button from '../GroupActions/Button';
import Icon from '../Icon';

interface ImportDropdownProps {
  items: Record<string, any>;
  fn: (filteredItems: string[]) => void;
}
const ImportDropdown: FC<ImportDropdownProps> = ({ items, fn }) => {
  const initialValues = items._keys.reduce((acc: Record<string, any>, curr: any) => {
    return { ...acc, [curr]: false };
  }, {});

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values) => {
        // @TODO: Figure out a better data structure here
        const filtered = Object.entries(values)
          .filter((item) => item[1])
          .map((value) => value[0]);
        fn(filtered);
      }}
    >
      <Form>
        <div className={styles.importDropdown}>
          <div className={styles.importDropdown__container}>
            {items._keys.map((item: string, index: number) => (
              <div key={item} className={styles.importDropdown__item}>
                <Icon
                  className={styles.importDropdown__icon}
                  name='circle'
                  color={items[item]?.['_60']?.hex}
                  size={14}
                />
                <ToggleField className={styles.importDropdown__toggle} name={item} label={item} />
              </div>
            ))}
          </div>
          <Button theme='accent' variant='rounded' label='Import Ramps' type='submit' />
        </div>
      </Form>
    </Formik>
  );
};

export default ImportDropdown;
